import React, { Component } from 'react';
import { Table, ButtonToolbar, Button, Grid, Row, Col, FormGroup, InputGroup, FormControl, Label, Modal } from 'react-bootstrap';

import { SimpleTextCommand } from '../../commands/SimpleTextCommand';
import { DataIdentifierOptionsFormatHelper } from '../../helpers/DataIdentifierOptionsFormatHelper';
import { HandleMessage } from '../../../HandleMessage';
import { HandleDialog } from '../../../HandleDialog';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { TableButton } from '../../../TableButton';

class SimpleTextOptionsDataIdentifier extends Component {
    render() {
        const { show, options } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>OPÇÕES PARA CONTEÚDO DO TEXTO</Modal.Header>
                <Modal.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Opção</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map((option, idx) =>
                                    <tr className="selectable" key={`data-${idx}`}>
                                        <td onClick={() => this.props.onSelect(DataIdentifierOptionsFormatHelper.getOptionValue(option))}>
                                            {DataIdentifierOptionsFormatHelper.getOptionText(option)}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <ButtonToolbar>
                        <Button onClick={this.props.onHide}>CANCELAR</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}

export class SimpleTextDataIdentifier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: this.props.selectedData,
            form: {
                id: 0,
                text: "",
                rotationAngle: 0,
                opacity: 1
            },
            styles: {
                text: null,
                rotationAngle: null,
                opacity: null
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10
            },
            textOptions: {
                show: false,
                options: [
                    "generationDate",
                    "lineCode",
                    "lineName",
                    "stopCode",
                    "stopName",
                    "schedules"
                ]
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            actions: {
                isLoading: true,
                isSaving: false,
                isDeleting: false
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions, table } = this.state;

            actions.isLoading = true;
            table.data = [];

            this.setState({
                table: table,
                actions: actions
            });
        }

        const simpleTextCommand = new SimpleTextCommand();
        simpleTextCommand.getAll(
            (a) => this.getAllSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ---------------------------

    getAllSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    saveSuccessCallback(result) {
        const { actions } = this.state;

        const dataIdStr = `${result.id}`;
        actions.isSaving = false;

        this.setState({
            selectedData: dataIdStr,
            actions: actions,
            form: {
                id: 0,
                text: "",
                rotationAngle: 0,
                opacity: 1
            },
            message: {
                show: true,
                message: "Texto criado com sucesso",
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);

        // Set the new id to the parent component
        this.props.onSelectData(dataIdStr)
    }

    deleteSuccessCallback(message) {
        const { actions } = this.state;

        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getAllData(true);
    }

    listErrorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationsErrorCallback(message) {
        const { actions } = this.state;

        actions.isSaving = false;
        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        this.getAllData(true);
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;
        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    // -----------------------

    onSelectData(data) {
        const dataIdStr = `${data.id}`;

        this.props.onSelectData(dataIdStr)

        this.setState({
            selectedData: dataIdStr
        });
    }

    onDeleteData(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o texto "${data.text}"?`,
                style: "warning",
                icon: "alert",
                argument: {
                    textId: data.id
                }
            }
        });
    }

    onAddData() {
        const { form } = this.state;

        let styles = {
            text: null,
            rotationAngle: null,
            opacity: null
        }

        if (0 >= form.text.length) {
            styles.text = "error"
        }
        if (0 >= form.rotationAngle.length || -360 > form.rotationAngle || 360 < form.rotationAngle) {
            styles.rotationAngle = "error"
        }
        if (0 >= form.opacity.length || 0 > form.opacity || 1 < form.opacity) {
            styles.opacity = "error"
        }

        this.setState({
            styles: styles
        });

        if (null === styles.text && null === styles.rotationAngle && null === styles.opacity) {
            const { form } = this.state;

            const simpleTextCommand = new SimpleTextCommand();
            simpleTextCommand.save(
                form,
                (a) => this.saveSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );

            this.setState({

            })
        }
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            actions.isDeleting = true;

            const simpleTextCommand = new SimpleTextCommand();
            simpleTextCommand.delete(
                argument.textId,
                (a) => this.deleteSuccessCallback(a),
                (a) => this.operationsErrorCallback(a)
            );
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    onExitTextOptions() {
        const { textOptions } = this.state;

        textOptions.show = false;

        this.setState({
            textOptions: textOptions
        });
    }

    // -----------------------

    handleOptionsClick() {
        const { textOptions } = this.state;

        textOptions.show = true;

        this.setState({
            textOptions: textOptions
        });
    }

    onSelectTextOption(value) {
        const { form } = this.state;

        form.text += value;

        this.setState({
            form: form
        }, () => {
            const textInput = document.getElementById("formDataText");

            textInput.focus();
            textInput.setSelectionRange(form.text.length, form.text.length);
        });

        this.onExitTextOptions();
    }

    // -----------------------

    selectedData(obj) {
        const { selectedData } = this.state;
        if (`${obj.id}` === selectedData) {
            return (
                <h5>
                    <Label bsStyle="success" className="icon-ok icon-img">&nbsp;</Label>
                </h5>
            );
        }
        else {
            return (
                <TableButton icon="icon-select" title="Selecionar" onClick={() => this.onSelectData(obj)} />
            );
        }
    }

    renderText(options, text) {
        let textToRender = [];
        let textLabels = [];
        
        let tempText = text;
        for (let i in options) {
            const option = DataIdentifierOptionsFormatHelper.getOptionValue(options[i]);
            const label = DataIdentifierOptionsFormatHelper.getOptionTextFromValue(option);

            let idx = 0;
            do {
                idx = tempText.indexOf(option);
                if (-1 !== idx) {
                    tempText = tempText.replace(option, new Array(option.length + 1).join("-"));
                    textLabels.push({ option: option, label: label, index: idx })
                }
            } while (-1 !== idx);

        }

        textLabels = textLabels.sort((a, b) => {
            if (a.index > b.index) return 1;
            if (b.index > a.index) return -1;
            return 0;
        });

        if(0 === textLabels.length) {
            textToRender.push(text);
        }
        else {
            let lastIndex = 0;
            for(let i in textLabels) {
                textToRender.push(text.substring(lastIndex, textLabels[i].index));
                textToRender.push(<Label key={`label-${i}`}>{textLabels[i].label}</Label>);

                lastIndex = textLabels[i].index + textLabels[i].option.length;
            }
            textToRender.push(text.substring(lastIndex));
        }

        return (
            <div>{textToRender}</div>
        );
    }

    render() {
        const { isLoading, isSaving, isDeleting } = this.state.actions;
        if (isLoading || isSaving || isDeleting) {
            return (
                <LoadingSpinner />
            );
        }

        const { selectedData, form, styles, table, textOptions, message, dialog } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Table responsive striped hover className="margin-top-10">
                                <thead>
                                    <tr>
                                        <th>Texto</th>
                                        <th>Rotação [-360..360]</th>
                                        <th>Opacidade [0..1]</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td>{this.renderText(textOptions.options, obj.text)}</td>
                                                <td>{obj.rotationAngle}&deg;</td>
                                                <td>{obj.opacity}</td>
                                                <td>{this.selectedData(obj)}</td>
                                                <td><TableButton disabled={`${obj.id}` === selectedData} icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteData(obj)} /></td>
                                            </tr>
                                        )
                                    }
                                    <tr>
                                        <td>
                                            <FormGroup bsSize="small"
                                                controlId="formDataText"
                                                className="margin-bottom-0"
                                                validationState={styles.text} >
                                                <InputGroup bsSize="small">
                                                    <FormControl
                                                        type="text"
                                                        placeholder="Texto"
                                                        value={form.text}
                                                        onChange={(e) => this.onChangeValue(e, 'text')} />

                                                    <InputGroup.Button>
                                                        <Button onClick={() => this.handleOptionsClick()}>OPÇÕES</Button>
                                                    </InputGroup.Button>
                                                </InputGroup>
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup bsSize="small"
                                                controlId="formDataRotationAngle"
                                                className="margin-bottom-0"
                                                validationState={styles.rotationAngle} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={-360}
                                                    max={360}
                                                    placeholder="Ângulo de Rotação"
                                                    value={form.rotationAngle}
                                                    onChange={(e) => this.onChangeValue(e, 'rotationAngle')} />
                                            </ FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup bsSize="small"
                                                controlId="formDataOpacity"
                                                className="margin-bottom-0"
                                                validationState={styles.opacity} >
                                                <FormControl
                                                    type="number"
                                                    step={0.1}
                                                    min={0}
                                                    max={1}
                                                    placeholder="Opacidade"
                                                    value={form.opacity}
                                                    onChange={(e) => this.onChangeValue(e, 'opacity')} />
                                            </ FormGroup>
                                        </td>
                                        <td colSpan={2}>
                                            <ButtonToolbar>
                                                <TableButton icon="icon-plus" title="Adicionar" onClick={() => this.onAddData()} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <SimpleTextOptionsDataIdentifier
                    options={textOptions.options}
                    show={textOptions.show}
                    onHide={() => this.onExitTextOptions()}
                    onSelect={(a) => this.onSelectTextOption(a)} />

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/SimpleTextDataIdentifier.js